export const usersEndpoints = {
    getAllPaginated: () => ({
      path: '/Admin/User/GetAll',
      method: 'GET' as const,
    }),
    delete: {
      path: '/Admin/User/BulkDeleteusers',
      method: 'PATCH' as const,
    }
  } as const;